/* Buddy pdplift: on desktop (>=1000px) move the long description into the slot under the gallery.
   Bikes: the buddy-specs section right after main-product. Accessories: .bb-why + .bb-about from the buy box.
   Below 1000px everything goes back to its original place (gallery -> buy box -> description). */
(function () {
  var mq = window.matchMedia('(min-width: 1000px)');
  var moved = []; // {el, marker}
  function slot() { return document.querySelector('.product.bb-pdplift > [data-bb-below-gallery]'); }
  function candidates() {
    var s = slot(); if (!s) return [];
    var main = s.closest('.shopify-section'); var out = [];
    var info = s.parentNode.querySelector('.product-info');
    if (info) ['.bb-why', '.bb-about'].forEach(function (q) { var e = info.querySelector('.bb-acc-info > ' + q); if (e) out.push(e); });
    if (!out.length && main) {
      var nx = main.nextElementSibling;
      if (nx && nx.classList.contains('shopify-section') && nx.querySelector(':scope > .bb-specs')) out.push(nx);
    }
    return out;
  }
  function place() {
    var s = slot(); if (!s) return;
    if (mq.matches) {
      if (!moved.length) candidates().forEach(function (el) {
        var m = document.createComment('bb-pdplift'); el.parentNode.insertBefore(m, el); moved.push({ el: el, marker: m }); s.appendChild(el);
      });
      var on = moved.length > 0; s.hidden = !on; s.parentNode.classList.toggle('bb-pdplift--on', on);
    } else restore();
  }
  function restore() {
    moved.forEach(function (o) { if (o.marker.parentNode) o.marker.parentNode.replaceChild(o.el, o.marker); });
    moved = []; var s = slot(); if (s) { s.hidden = true; s.parentNode.classList.remove('bb-pdplift--on'); }
  }
  // product change replaces the whole .product: put the bike section back first (capture runs before the rerender)
  document.addEventListener('product:rerender', function (e) {
    if (e.detail && e.detail.productChange) restore();
  }, true);
  // variant change re-renders the liquid blocks (fresh .bb-why/.bb-about appear in the buy box): drop stale copies, re-place
  document.addEventListener('product:rerender', function () {
    setTimeout(function () {
      moved = moved.filter(function (o) { if (!o.marker.isConnected) { o.el.remove(); return false; } return true; });
      var s = slot(); if (moved.length && s && !s.contains(moved[0].el)) restore();
      place();
    }, 0);
  });
  (mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
